import { render, staticRenderFns } from "./AppAdminAddAdminForm.vue?vue&type=template&id=6af46834&"
import script from "./AppAdminAddAdminForm.vue?vue&type=script&lang=ts&"
export * from "./AppAdminAddAdminForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports